module.exports = __webpack_public_path__ + "ac233cde5ade9d9cc8ff069ac9445992.pdf";